export default "__VITE_ASSET__CGKUEXcg__"